import React, { Suspense, useContext } from 'react';
import { ThemeContext } from '../../features/theme/presentation/ThemeContext';

// This is the layout the login screen and the 404 render through, so it is
// one of the few modules on the first visit's critical path. `SideNav`
// brings framer-motion with it — 93 KB measured — for a nav that is behind
// `showSideNav`, a prop no caller currently turns on. Lazy, the animation
// library is fetched only if something does. The nav positions itself
// absolutely over the page, so there is no space to reserve while it loads
// and nothing below it moves when it arrives.
const SideNav = React.lazy(() =>
  import('../../components/Menu/SideNav/SideNav')
);

const Layout = ({ children, showSideNav = false }) => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div
      className={`max-w-screen-full bg ${
        darkMode ? 'bg-dark' : 'bg-light'
      } flex min-h-screen`}
    >
      {showSideNav && (
        <Suspense fallback={null}>
          <SideNav />
        </Suspense>
      )}

      <main className="flex-grow">{children}</main>
    </div>
  );
};

export default Layout;
